import styles from 'styles/styles.module.css';

export default function Footer() {
  return (
    <footer className="border-top bg-white">
      <div className="mx-auto d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 px-4 px-md-5 py-3 text-muted small">
        <p className={`mb-0 text-secondary fw-light  ${styles['text-xs']}`}>
          Prevencor Marília — Centro de Cardiologia
        </p>
        <p className={`mb-0 text-secondary fw-light  ${styles['text-xs']}`}>
          Desenvolvido por{' '}
          <a
            href="https://www.moraes-tech.com/"
            target="_blank"
            className="text-decoration-none text-secondary"
          >
            © MoraesTech
          </a>{' '}
          · v.985 · 04/11/2026
        </p>
      </div>
    </footer>
  );
}
